import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { DATA_VOLUME } from "utils/localStorage";

const initialState = {
  volume: sessionStorage.getItem(DATA_VOLUME) || 0.5,
};

const volumeSlice = createSlice({
  name: "volume",
  initialState,
  reducers: {
    setVolume(state, { payload }) {
      state.volume = payload;
    },
  },
});

export const { actions } = volumeSlice;
export default volumeSlice.reducer;

export const useVolumeActions = () => {
  const dispatch = useDispatch();

  const setVolume = (params) => {
    dispatch(volumeSlice.actions.setVolume(params));
  };

  return {
    setVolume,
  };
};
